export default "__VITE_PUBLIC_ASSET__1350b5c0__"